import React from "react";
import { Typography, Box } from "@material-ui/core";
import * as Yup from "yup";
import { Formik, ErrorMessage } from "formik";
import { TYPES } from "./instagramForm.container";
import { ModalFooter, ContentWrapper } from "../../modal";
import Input from "components/input/inputTextField";
import { getLang } from "app/feature/constants";

export default function InstagramFormComponent({
  type,
  initialValues,
  handleDelete,
  handleSubmit,
  lang,
  handleClose
}) {
  return (
    <Formik
      initialValues={{
        URL: initialValues.URL
      }}
      validationSchema={Yup.object({
        URL: Yup.string()
          .matches(
            /(?:(?:http|https):\/\/)?(?:www.)?instagram.com\/(p|reel)\/(?:(?:\w)*#!\/)?(?:\/)?(?:[?\w-]*\/)?([\w-]*)?/,
            getLang(lang,"message.error.FORM_VALIDATE_MATCH_URL_INSTAGRAM")
          )
          .required(getLang(lang,"message.error.FORM_VALIDATE_REQUIRED"))
      })}
      onSubmit={handleSubmit}
    >
      {formik => (
        <form onSubmit={formik.handleSubmit}>
          <ContentWrapper>
            <Typography variant="body2" gutterBottom>
              {getLang(lang,"label.INSERT_INSTAGRAM_URL")} <Typography style={{ color: "#DE350B", display: 'inline-block' }}>*</Typography>
            </Typography>
            <Input
              required
              hiddenLabel
              variant="filled"
              size="small"
              margin="dense"
              placeholder={getLang(lang,"placeholder.ENTER_URL_HERE")}
              fullWidth
              {...formik.getFieldProps("URL")}
              value={type === TYPES[2] ? initialValues.URL : formik.values.URL}
              error={formik.touched.URL && formik.errors.URL ? true : false}
              helperText={ErrorMessage({ name: "URL" })}
              inputProps={{ readOnly: type === TYPES[2] }}
            />
            <Box display="flex">
              <Typography variant="body2">
                <span style={{ color: "gray" }}>{getLang(lang,"label.EXAMPLE")}&nbsp;</span>
              </Typography>
              <Box display="flex" flexDirection="column">
                <Typography variant="body2">https://www.instagram.com/p/CA-D9h6FqN-</Typography>
                <Typography variant="body2">https://www.instagram.com/reel/DACkjP_J5so</Typography>
              </Box>
            </Box>
            <Box mt={3}>
              <Typography variant="caption" color="textSecondary">
              <Typography style={{ color: "#DE350B", display: 'inline-block' }}>*</Typography> {getLang(lang,"label.REQUIRED_FIELD")}
              </Typography>
            </Box>
          </ContentWrapper>
          <ModalFooter
            handleDelete={handleDelete}
            showDelete={type !== TYPES[0]}
            handleClose={handleClose}
          />
        </form>
      )}
    </Formik>
  );
}
